import { Message } from 'semantic-ui-react';

type Props = {
  examinerNames: string[];
};

export const ExaminerAllocationChangedEmailNotificationMessage = ({ examinerNames }: Props) => {
  if (examinerNames.length === 0) return null;

  return (
    <Message
      info
      icon="info"
      content={
        <>
          This action will trigger e-mail notification to{' '}
          <strong>{examinerNames.join(', ')}</strong>.
          <br />
          Do you want to continue?
        </>
      }
    ></Message>
  );
};
